import React from "react";

export interface ConfigContextData {
  stylesheetUrl?: string;
  publishableKey: string;
  iconBg?: string;
  iconTextColor?: string;
  iconText?: string;
  customerData?: string;
  headline?: string;
  subheading?: string;
  categoryHeader?: string;
  categories?: string[];
  messagePlaceholder?: string;
  submitText?: string;
  successText?: string;
  errorText?: string;
  launchSelector?: string;
  debug?: boolean;
  styles?: {
    headerBgColor?: string;
    headerTextColor?: string;
    buttonBgColor?: string;
    buttonTextColor?: string;
  };
}

export const context = React.createContext<ConfigContextData>(
  {} as ConfigContextData
);

export const ConfigProvider = context.Provider;
export const ConfigConsumer = context.Consumer;

export default context;
